export default {
	gradlinc: {
		logo: require('~~/assets/images/gradlinc/logo.svg'),
		logoDark: require('~~/assets/images/gradlinc/logo-dark.svg'),
		logoFull: require('~~/assets/images/gradlinc/logo-full-dark.svg'),
		logoFullDark: require(`~~/assets/images/gradlinc/logo-full-dark.svg`),
		primary: '8,62,127',
		primaryDark: '210,174,109',
		secondary: '210,174,109',
	},
	sun: {
		//Standard
		logo: require('~~/assets/images/sun/logo.svg'),
		logoDark: require('~~/assets/images/sun/logo-dark.svg'),
		logoFull: require('~~/assets/images/sun/logo-full.svg'),
		logoFullDark: require(`~~/assets/images/sun/logo-full.svg`),
		primary: '98, 33, 60',
		primaryDark: '183, 153, 98',
		secondary: '183, 153, 98',

		//Navbar
		navbar: null,
		navbarDark: '36,40,55',
		navbarText: null,
		navbarTextDark: null,
		navbarTextActive: '183, 153, 98',
		navbarTextActiveDark: '183, 153, 98',

		//Job Card
		jobCardBanner: null,
		jobCardBannerDark: '98, 33, 60',
		jobCardBannerActive: null,
		jobCardBannerActiveDark: '183, 153, 98',
		jobCardBannerText: '255,255,255',
		jobCardBannerTextDark: '255,255,255',

		//Apply Button
		applyButton: null,
		applyButtonDark: null,
		applyButtonText: null,
		applyButtonTextDark: '255, 255, 255',
	},
	sbs: {
		//Standard
		logo: require('~~/assets/images/sbs/logo.svg'),
		logoDark: require('~~/assets/images/sbs/logo-dark.svg'),
		logoFull: require('~~/assets/images/sbs/logo-full.svg'),
		logoFullDark: require(`~~/assets/images/sbs/logo-full.svg`),
		primary: '98, 33, 60',
		primaryDark: '183, 153, 98',
		secondary: '183, 153, 98',

		//Navbar
		navbar: null,
		navbarDark: '36,40,55',
		navbarText: null,
		navbarTextDark: null,
		navbarTextActive: '183, 153, 98',
		navbarTextActiveDark: '183, 153, 98',

		//Job Card
		jobCardBanner: null,
		jobCardBannerDark: '98, 33, 60',
		jobCardBannerActive: null,
		jobCardBannerActiveDark: '183, 153, 98',
		jobCardBannerText: '255,255,255',
		jobCardBannerTextDark: '255,255,255',

		//Apply Button
		applyButton: null,
		applyButtonDark: null,
		applyButtonText: null,
		applyButtonTextDark: '255, 255, 255',
	},
	uct: {
		logo: require('~~/assets/images/uct/logo.svg'),
		logoDark: require('~~/assets/images/uct/logo-dark.svg'),
		logoFull: require('~~/assets/images/uct/logo-full-dark.svg'),
		logoFullDark: require(`~~/assets/images/uct/logo-full-dark.svg`),
		primary: '0,60,105',
		primaryDark: '0,152,219',
		secondary: '0,152,219',
	},
	eduvos: {
		logo: require('~~/assets/images/eduvos/logo.svg'),
		logoDark: require('~~/assets/images/eduvos/logo-dark.svg'),
		logoFull: require('~~/assets/images/eduvos/logo-full.svg'),
		logoFullDark: require(`~~/assets/images/eduvos/logo-full-dark.svg`),
		primary: '21,48,93',
		primaryDark: '41,171,226',
		secondary: '41,171,226',

		//Navbar
		navbar: '255,255,255',
		navbarDark: '21,48,93',
		navbarText: '55,63,65',
		navbarTextDark: null,
		navbarTextActive: '41,171,226',
		navbarTextActiveDark: '41,171,226',
	},
};
